import React from "react";
import { Lozenge as NovusLozenge } from "@arcadis-intelligence/novus-design-system";
export const Lozenge: React.FC<React.ComponentProps<typeof NovusLozenge>> = (props) => {
    return <NovusLozenge {...props} />;
};
